<template>
    <div class="transactionFiltersWrap">
        <div v-if="$mq=='sm'" class="transactionFiltersOverlay">
            <div @click="$emit('modalToggle')" class="transactionFiltersBackgroundClick">
            </div>
        </div>
        <div class="transactionFilters frame">
            <div class="inputCheckboxWrap">
                <input v-model="filterVal" id="credits" type="radio" name="filter" value="credit">
                <label class="radio" for="credits"></label>
                <label class="text" for="credits">{{'components/transactions/transaction-filters.credits' | trans}}</label>
            </div>
            <div class="inputCheckboxWrap">
                <input v-model="filterVal" id="debits" type="radio" name="filter" value="debit">
                <label class="radio" for="debits"></label>
                <label class="text" for="debits">{{'components/transactions/transaction-filters.debits' | trans}}</label>
            </div>
            <div class="inputCheckboxWrap">
                <input v-model="filterVal" id="others" type="radio" name="filter" value="other">
                <label class="radio" for="others"></label>
                <label class="text" for="others">{{'components/transactions/transaction-filters.all' | trans}}</label>
            </div>
        </div>
        <div  v-if="$mq=='lg'" class="right">
            <v-select
                :options="dates"
                v-model="selectedDate"
                :placeholder="'components/transactions/transaction-filters.search-by-date' | trans"
            >
            </v-select>
            <button
				@click="printTransactions"
				v-if="$mq=='lg'"
				class="btnPrint"><img src="/assets/img/print.svg">
			</button>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import { printPage } from '../../helpers/printPage';

    export default {
        props: {
            filterValue: {
                type: String
            },
            dates: {
                type: Array
            }
        },
        data() {
            return {
                filterVal: this.filterValue,
                selectedDate: '',
            }
        },

        components : { vSelect },
        computed : {},
        methods: {
            printTransactions(){
                let url = "/ajax/api/transactions/print";
                printPage(url, {
                    'filter': this.filterVal,
					'date': this.selectedDate
				});
			}
		},
        watch: {
            filterVal: function () {
                this.$emit('setTransactionFilters', this.filterVal);
            },
            selectedDate: function () {
                this.$emit('setFiltersDate', this.selectedDate);
            },
        }
    }
</script>

